import React from "react";
import { usePurchasePlanModel } from "../purchasePlanModel";
import { ISearchValue, SearchTypeEnum } from "@/components/YhPageHeader/Types";
import { YhPageHeader } from "@/components/YhPageHeader";
import { useDictModel } from "@/views/base/dict/dictModel";
import { DictCodeEnmu } from "@/types/VrmSaDictEnums";
import useGlobalModel from "@/model/globalModel";

export function PageHeader() {
    const queryTypeOption = [
        { label: "所有订单", value: 1 },
        { label: "未到货订单", value: 2 },
        { label: "超过24h 未到货订单", value: 3 },
    ]

    const {
        searchParam,
        initPgCfg,
        updateSearchParam,
        resetSearchParam,
        loadData
    } = usePurchasePlanModel();
    const { getSelectedDictOne } = useDictModel();
    const { shopAndOrg: { shopType }, allShopDs, user: { roles } } = useGlobalModel();

    const searchFields = [
        {
            type: SearchTypeEnum.Input,
            placeholder: "采购订单号",
            fieldName: "planCode",
        },
        {
            type: SearchTypeEnum.Select,
            placeholder: "订单类型",
            fieldName: "purchaseTypeCode",
            options: getSelectedDictOne(DictCodeEnmu.PURCHASE_TEPE),
        },
        // {
        //     type: SearchTypeEnum.Select,
        //     placeholder: "商品类型",
        //     fieldName: "materialTypeCode",
        //     options: getSelectedDictOne(DictCodeEnmu.MATERIAL_TYPE),
        // },
        // {
        //     type: SearchTypeEnum.Input,
        //     placeholder: "制单人",
        //     fieldName: "createUser"
        // },
        {
            type: SearchTypeEnum.Select,
            placeholder: "单据状态",
            fieldName: "status",
            options: getSelectedDictOne(DictCodeEnmu.PURCHASE_PLAN),
        },

        ...(() => {
            if (!roles.includes('hd-supplier')) {
                return [{
                    type: SearchTypeEnum.Select,
                    placeholder: "查询类型",
                    fieldName: "queryType",
                    options: queryTypeOption,
                },]
            } else {
                return [
                ]
            }
        })(),
        {
            type: SearchTypeEnum.Select,
            placeholder: "所属站点",
            fieldName: "shopId",
            options: allShopDs,
            disabled: shopType === 0 ? false : true
        }
        // {
        //     type: SearchTypeEnum.RangePicker,
        //     fieldName: "",
        //     placeholder: ["制单日期起始", "制单日期结束"],
        //     rangePickerFieldName: ["startTime", "endTime"],
        //     format: "YYYY-MM-DD",
        // },
    ]

    return (
        <>
            <YhPageHeader
                size="small"
                title="采购订单"
                triggerSearch={true}
                searchValues={searchParam as ISearchValue}
                searchFields={searchFields}
                onChange={updateSearchParam}
                handleSearch={(params) => { loadData(initPgCfg, { ...searchParam, ...params }) }}
                handleReset={resetSearchParam}
            />
        </>
    );
}